import { render } from "./documents-table-deprecated.vue?vue&type=template&id=0afbc3f2"
import script from "./documents-table-deprecated.vue?vue&type=script&lang=js"
export * from "./documents-table-deprecated.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__